var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { Text } from "../../../../../Atoms";
import { lighten } from "@mui/material";
var FilterOption = function (_a) {
    var filterOption = _a.filterOption, selectOption = _a.selectOption, active = _a.active;
    /**
     * pass back the filter selected to set as the active filter
     */
    var handleClick = function () {
        selectOption(filterOption);
    };
    return (_jsxs(Stack, __assign({ alignItems: "center", direction: "row", py: 2.5, pl: 3, onClick: handleClick, sx: {
            cursor: "pointer",
            "&:hover": {
                background: function (theme) {
                    return lighten(theme.palette.primary.main, 0.88);
                },
            },
        } }, { children: [_jsx(CheckIcon, { fontSize: "small", style: {
                    visibility: active ? "visible" : "hidden",
                } }), _jsx(Text, __assign({ ml: 3, variant: "body2", "data-testid": "".concat(filterOption.label, "-").concat(active ? "active" : "inactive") }, { children: filterOption.label }))] })));
};
export default FilterOption;
